import React, { FC, useMemo, useState } from "react";
import Typography from "../../typography";
import Button from "../../button";
import Input from "../../input";
import Tabs from "../../tabs";
import { icons } from "../../../icons";
import {
  Container,
  HeadWrapper,
  IconButton,
  BodyModal,
  TabsWrapper,
  ActionsWrapper,
} from "./styles";
import { HeadLine3 } from "../../typography/styled";
import { useTranslation } from "react-i18next";

type CreditModalProps = {
  closeModalCancel: () => void;
  closeModal: (data: any) => void;
  alertTitle: string;
  dataToEdit: {
    currency: string;
    clientName: string;
  };
  loading?: boolean;
  loadingComplete?: boolean;
};

const CreditModeTabs = [
  { title: "ADD_CREDIT", slug: "add", id: "add" },
  { title: "SUBTRACT_CREDIT", slug: "subtract", id: "subtract" },
];

const EditClientCredit: FC<CreditModalProps> = ({
  closeModal,
  closeModalCancel,
  alertTitle,
  dataToEdit,
  loading,
  loadingComplete,
}) => {
  const [t] = useTranslation();
  const [mode, setMode] = useState<string>("add");
  const [amount, setAmount] = useState<string>("");
  const [touched, setTouched] = useState<boolean>(false);

  const amountError = useMemo(() => {
    if (!touched) return "";
    if (!amount || Number(amount) <= 0) {
      return t("REQUIRED_FIELD");
    }
    return "";
  }, [amount, touched, t]);

  const handleSubmit = () => {
    setTouched(true);
    if (amountError) {
      return;
    }
    closeModal({
      add_credit: mode === "add",
      amount,
      currency: dataToEdit?.currency,
      source_currency: dataToEdit?.currency,
    });
  };

  return (
    <Container>
      <HeadWrapper>
        <HeadLine3>{alertTitle}</HeadLine3>
        <IconButton onClick={closeModalCancel}>
          <img src={icons.CloseIcon} alt="close" />
        </IconButton>
      </HeadWrapper>
      <BodyModal>
        <TabsWrapper>
          <Tabs
            blockNavigate
            size="display"
            tabs={CreditModeTabs.map((tab) => ({
              ...tab,
              title: t(tab.title),
            }))}
            location={mode}
            onChange={setMode}
            customStyles={{ width: "100%" }}
          />
        </TabsWrapper>
        <Input
          required
          fieldName="amount"
          title={t("AMOUNT_WITH_CURRENCY", { currency: dataToEdit?.currency })}
          placeholder=""
          type="number"
          value={amount}
          onBlur={() => setTouched(true)}
          manualTouched={touched}
          manualErr={amountError}
          handleChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setAmount(e.target.value)
          }
          containerCustom={{ width: "100%" }}
        />
        <ActionsWrapper>
          <Button
            variant="stroke"
            size="display"
            customStyles={{ flex: 1, justifyContent: "center" }}
            onClick={closeModalCancel}
            title={t("CANCEL")}
          />
          <Button
            variant="primary"
            size="display"
            loading={loading}
            loadingComplete={loadingComplete}
            customStyles={{ flex: 1, justifyContent: "center" }}
            onClick={handleSubmit}
            title={mode === "add" ? t("ADD_CREDIT") : t("SUBTRACT_CREDIT")}
          />
        </ActionsWrapper>
      </BodyModal>
    </Container>
  );
};

export default EditClientCredit;
